export enum IconNames {
  Discord = 'discord',
  Refresh = 'refresh',
  Settings = 'settings',
  Swap = 'swap',
  Waterdrop = 'waterdrop',
  X = 'x',
  ArrowDown = 'arrow-down',
  Layers = 'layers',
  Library = 'library',
  Coin = 'coin',
  Search = 'search',
}
